import React, { useEffect, useState } from 'react';
import { Card, Collapse, Spin, message, Empty, Pagination, Modal } from 'antd';
import dayjs from 'dayjs';
import { getAnnouncements } from '../../api/announcements';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

const ParentAnnouncements = () => {
  const [loading, setLoading]             = useState(true);
  const [announcements, setAnnouncements] = useState([]);
  const [pagination, setPagination]       = useState({ current: 1, pageSize: 10, total: 0 });
  const [lightboxUrl, setLightboxUrl]     = useState(null);

  const fetchAnnouncements = async (page = 1) => {
    setLoading(true);
    try {
      const res = await getAnnouncements({ page, per_page: 10 });
      setAnnouncements(res.data.data || []);
      setPagination({
        current:  res.data.current_page,
        pageSize: res.data.per_page,
        total:    res.data.total,
      });
    } catch {
      message.error('Duyurular yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAnnouncements(); }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><Spin size="large" /></div>;

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold mb-0">Duyurular</h2>

      <Card size="small">
        {announcements.length === 0 ? (
          <Empty description="Henüz duyuru yok." />
        ) : (
          <>
            <Collapse
              ghost
              items={announcements.map(a => ({
                key: a.id,
                label: (
                  <div className="flex justify-between items-center w-full pr-4">
                    <strong>{a.title}</strong>
                    <span className="text-gray-400 text-sm shrink-0 ml-2">
                      {dayjs(a.published_at).format('DD.MM.YYYY')}
                    </span>
                  </div>
                ),
                children: (
                  <div className="px-4">
                    {a.image_url && (
                      <img
                        src={a.image_url}
                        alt=""
                        style={{ maxHeight: 200, borderRadius: 8, marginBottom: 10, display: 'block', cursor: 'zoom-in' }}
                        onClick={() => setLightboxUrl(a.image_url)}
                      />
                    )}
                    <div
                      className="text-gray-600 ql-editor prose max-w-none"
                      dangerouslySetInnerHTML={{ __html: sanitizeHtml(a.body) }}
                    />
                  </div>
                ),
              }))}
            />
            {pagination.total > pagination.pageSize && (
              <div className="flex justify-end mt-4">
                <Pagination
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onChange={fetchAnnouncements}
                  showTotal={t => `Toplam ${t} duyuru`}
                  size="small"
                />
              </div>
            )}
          </>
        )}
      </Card>

      <Modal
        open={!!lightboxUrl}
        onCancel={() => setLightboxUrl(null)}
        footer={null}
        width="90vw"
        style={{ maxWidth: 1000, top: 20 }}
        styles={{ body: { padding: 0, textAlign: 'center', background: '#000' } }}
        destroyOnClose
      >
        {lightboxUrl && (
          <img
            src={lightboxUrl}
            alt=""
            style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain', display: 'block', margin: '0 auto' }}
          />
        )}
      </Modal>
    </div>
  );
};

export default ParentAnnouncements;
